import React, {Component} from 'react';
import {CardMedia, withStyles} from "@material-ui/core";
import Button from "@material-ui/core/Button";
import i18n from "../../i18n";

const windowConfig = 'toolbar=0,status=0,width=650,height=900';

class PreviewButton extends Component {

    constructor(props) {
        super(props);
        this.state = {
            file: this.props.file,
        };
    }

    render() {
        return (
            <Button
                title={i18n.get('file.open_preview')}
                onClick={() => window.open(this.getUrl(), 'docPrev', windowConfig)}>
                <CardMedia
                    component={"img"}
                    src={this.getImage()}
                    className={this.props.className}
                />
            </Button>
        );
    }

    getUrl() {
        return this.state.file.sRoutePreview || this.state.file.sRoute.replace('/f/', '/f/preview/')

    }

    getImage() {
        return this.state.file.sPrevPic || this.state.file.sRoute + '_200_';
    }
}

const styles = theme => ({});


export default withStyles(styles)(PreviewButton);



// WEBPACK FOOTER //
// ./resources/assets/js/components/File/PreviewButton.jsx